<template>
  <div class="ops-modern compact">
    <div class="nav-bar-operations">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        @click="backMainPanel"
        class="logo-button"
      />
    </div>

    <div class="tab-content mt-3">
      <div class="text-operations card-strip">
        <div>
          <h2>Siniestros activos: {{ totalIncidents }}</h2>
        </div>
        <div class="thermometer">
          <div class="bar active" :style="{ width: totalIncidents ? '100%' : '0%' }"></div>
        </div>
      </div>

      <div class="action-buttons">
        <button v-if="canAccessIncidentMaster" @click="incidentMaster" class="action-button">Maestro de Siniestros</button>
        <button v-if="canCreateIncident" @click="newIncident" class="action-button action-primary">Nuevo Siniestro</button>
        <button @click="backMaintenance" class="action-button">Volver a Mantenimiento</button>
      </div>

      <div class="table-container card-wrap">
        <div v-if="!canViewTable" class="no-access">
          No tienes permisos para ver el listado de siniestros.
        </div>
        <h2>Siniestros</h2>
        <table v-if="canViewTable" class="table table--incidents">
          <thead>
            <tr>
              <th>
                Siniestro
                <button class="sort-btn" @click="toggleSort('incident_number')">
                  <span v-if="isSorted('incident_number')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span>
                </button>
              </th>
              <th>
                Unidad
                <button class="sort-btn" @click="toggleSort('unit')">
                  <span v-if="isSorted('unit')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span>
                </button>
              </th>
              <th>
                Solicitud
                <button class="sort-btn" @click="toggleSort('request_time')">
                  <span v-if="isSorted('request_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span>
                </button>
              </th>
              <th>Descripción</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="incident in incidents" :key="incident.id">
              <td>
                <span class="note-pill" @click="editIncident(incident.id)">
                  {{ incident.incident_number || incident.id }}
                </span>
              </td>
              <td>{{ incident.unit_short_id || incident.unit || 'N/A' }}</td>
              <td>{{ formatDateTime(incident.request_time) }}</td>
              <td class="truncate">{{ incident.accident_description || 'N/A' }}</td>
              <td>
                <span :class="statusClass(incident)">{{ statusLabel(incident) }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="canViewTable" class="pagination-container">
          <button @click="prevPage" :disabled="currentPage === 1">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
          <span
            v-for="pageNumber in totalPages"
            :key="pageNumber"
            @click="goToPage(pageNumber)"
            :class="{ active: pageNumber === currentPage }"
          >
            {{ pageNumber }}
          </span>
          <button @click="nextPage" :disabled="currentPage >= totalPages">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'IncidentsManagement',
  data() {
    return {
      permissions: [],
      incidents: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      sortState: { by: '', dir: 'asc' },
    }
  },
  computed: {
    canViewTable() {
      return this.hasAnyPerm(['maintenance.view_incident_table'])
    },
    canCreateIncident() {
      return this.hasAnyPerm(['maintenance.create_incident'])
    },
    canViewIncident() {
      return this.hasAnyPerm(['maintenance.view_incident'])
    },
    canAccessIncidentMaster() {
      return this.hasAnyPerm(['maintenance.view_incident_master'])
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize))
    },
    totalIncidents() {
      return this.totalCount
    },
  },
  mounted() {
    this.loadPermissions()
    if (!this.canViewTable) {
      Swal.fire('Sin acceso', 'No tienes permisos para ver el listado de siniestros.', 'warning')
      this.$router.push({ name: 'MainPanel' })
      return
    }
    this.fetchIncidents(1)
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    backMainPanel() {
      this.$router.push({ path: '/main-panel' })
    },
    backMaintenance() {
      this.$router.push({ path: '/modulo-mantenimiento' })
    },
    incidentMaster() {
      if (!this.canAccessIncidentMaster) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver el maestro de siniestros.', 'warning')
        return
      }
      this.$router.push({ path: '/maestro-siniestros' })
    },
    newIncident() {
      this.$router.push({ path: '/new-incident' })
    },
    editIncident(incidentId) {
      if (!this.canViewIncident) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver el siniestro.', 'warning')
        return
      }
      this.$router.push({ path: `/unit-incidents/${incidentId}` })
    },
    formatDateTime(value) {
      if (!value) return 'N/A'
      return `${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)} ${value.substring(11, 16)}`
    },
    statusLabel(incident) {
      if (incident.incident_status === 2) return 'Solucionado'
      if (incident.incident_status === 1) return 'Pendiente'
      return incident.incident_status_label || 'Pendiente'
    },
    statusClass(incident) {
      return incident.incident_status === 2 ? 'status status--ok' : 'status status--warn'
    },
    isSorted(field) {
      return this.sortState.by === field
    },
    orderingFor() {
      if (!this.sortState.by) return ''
      const prefix = this.sortState.dir === 'desc' ? '-' : ''
      return `&ordering=${prefix}${this.sortState.by}`
    },
    toggleSort(field) {
      if (this.sortState.by === field) {
        this.sortState.dir = this.sortState.dir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortState.by = field
        this.sortState.dir = 'asc'
      }
      this.fetchIncidents(1)
    },
    async fetchIncidents(page = 1) {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        if (!this.canViewTable) {
          return
        }
        const orderingParam = this.orderingFor()
        const response = await axios.post(
          `${apiDirectory}/get-unit-incidents-filtered?page=${page}&page_size=${this.pageSize}${orderingParam}`,
          { incident_status: [1] }
        )
        this.incidents = response.data.results || []
        this.totalCount = response.data.count || 0
        this.currentPage = page
      } catch (error) {
        console.error('There was an error fetching incidents', error)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.fetchIncidents(this.currentPage - 1)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.fetchIncidents(this.currentPage + 1)
      }
    },
    goToPage(pageNumber) {
      this.fetchIncidents(pageNumber)
    },
  },
}
</script>

<style scoped>
.ops-modern {
  --brand: #ffc434;
  --brand-ink: #3b2b00;
  --ink: #111827;
  --muted: #6b7280;
  --line: #e5e7eb;
  --bg: #f7f7f9;
  --card: #ffffff;
  --radius-lg: 16px;
  --radius-md: 12px;
  --radius-sm: 8px;
  --shadow-1: 0 8px 18px rgba(0,0,0,.06);
  --shadow-2: 0 2px 8px rgba(0,0,0,.08);
}

.ops-modern { background: var(--bg); }

.no-access{
  margin: 16px 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f3c7c7;
  background: #fff3f3;
  color: #9b1c1c;
  font-weight: 700;
}

.ops-modern .nav-bar-operations {
  position: sticky; top: 0; left: 0; width: 100%;
  height: 10vh;
  background-color: var(--brand);
  display: flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow-2);
  z-index: 1000;
}
.ops-modern .logo-button { height: 70%; cursor: pointer; }

.card-strip {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-1);
  padding: 10px 14px;
  margin: 8px 12px 12px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-items: center;
}
.text-operations h2 {
  margin: 0; color: var(--ink); font-size: 1.1rem; font-weight: 800;
}

.action-buttons {
  display: flex; justify-content: flex-end; gap: 8px;
  margin: 10px 12px 0;
}
.action-button {
  padding: 10px 14px; border: 1px solid var(--line);
  background: #111827; color: #fff; border-radius: var(--radius-md);
  font-weight: 700; box-shadow: var(--shadow-2);
  transition: transform .12s, box-shadow .12s, opacity .12s;
}
.action-button:hover { transform: translateY(-1px); }

.card-wrap {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-1);
  padding: 12px;
  margin: 12px;
}
.card-wrap > h2 {
  margin: 4px 6px 10px; font-size: 1rem; font-weight: 800; color: var(--ink);
}

.thermometer {
  height: 14px;
  background: #eef2f7;
  border-radius: 999px;
  display: flex; overflow: hidden;
  border: 1px solid var(--line);
}
.bar { height: 100%; }
.bar.active { background: #16a34a; }

.table-container { overflow-x: auto; }
.table {
  width: 100%;
  border-collapse: separate; border-spacing: 0;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-1);
  table-layout: fixed;
  font-size: .85rem;
}
.table thead th {
  position: sticky; top: 0; z-index: 1;
  background: #f5f6f8;
  color: #475163;
  font-weight: 600;
  border-bottom: 1px solid var(--border);
  padding: 6px 8px;
  white-space: nowrap;
}
.table tbody td {
  padding: 10px 12px; border-bottom: 1px solid var(--line);
  color: var(--ink); vertical-align: top; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.table tbody tr:nth-child(even) td { background: #fcfcfd; }
.table tbody tr:hover td { background: #eef3ff; color: #0f172a; }

.table--incidents td:nth-child(1), .table--incidents th:nth-child(1) { width: 110px; }
.table--incidents td:nth-child(2), .table--incidents th:nth-child(2) { width: 130px; }
.table--incidents td:nth-child(3), .table--incidents th:nth-child(3) { width: 170px; }
.table--incidents td:nth-child(4), .table--incidents th:nth-child(4) { width: 360px; }
.table--incidents td:nth-child(5), .table--incidents th:nth-child(5) { width: 120px; }

.truncate {
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.note-pill {
  display: inline-block;
  color: #fff;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 999px;
  cursor: pointer;
  background: #111827;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

.status {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px; border-radius: 999px; font-weight: 800; font-size: .85rem;
  border: 1px solid transparent;
}
.status--ok { background: #e8f7ef; color: #0f7a3b; border-color: #bde6cd; }
.status--warn { background: #fff6e5; color: #8a6100; border-color: #f2dfb2; }
.status--info { background: #eaf3ff; color: #134c9a; border-color: #c6ddff; }

.sort-btn {
  margin-left: 6px; border: 0; background: transparent;
  cursor: pointer; font-size: .8rem; color: #6b7280;
}

.pagination-container {
  display: flex; justify-content: center; align-items: center; gap: 10px;
  margin: 12px 0 4px;
}
.pagination-container span {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 6px 10px; border-radius: 10px; cursor: pointer;
  border: 1px solid var(--line); background: #fff;
}
.pagination-container span.active {
  background: var(--brand); color: var(--brand-ink); border-color: transparent;
}
.pagination-container button {
  border: 1px solid var(--line); background: #fff; border-radius: 10px;
  padding: 4px 8px; cursor: pointer;
}
.pagination-container button:disabled { opacity: .4; cursor: not-allowed; }
</style>
